import React from 'react';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';
import { WebsiteBuilderSidebarVM } from './website-builder-sidebar.viewmodel';
import { SidebarHeader } from './_sidebar-header/sidebar-header';
import { SidebarContent } from './_sidebar-content/sidebar-content';
import { MinimizeIcon } from '../../../global/icons/icons';
import {
    NEW_PAGE_PLACEHOLDER_TEXT,
    WEBSITE_BUILDER_EDIT_HUB_TAB_TEXT,
    WEBSITE_BUILDER_EDIT_PAGE_TAB_TEXT,
    WEBSITE_BUILDER_EDITOR_TEXT
} from '../../event-hubs.text';
import './website-builder-sidebar.scss';

type WebsiteBuilderSidebarPresentationProps = {
    vm: WebsiteBuilderSidebarVM;
};

export const WebsiteBuilderSidebarPresentation = observer(({ vm }: WebsiteBuilderSidebarPresentationProps) => {
    if (vm.isMinimized()) {
        return (
            <div className='website-builder-sidebar website-builder-sidebar--minimized' onClick={vm.toggleMinimize}>
                <span className='website-builder-sidebar__editor-label'>
                    <FormattedMessage {...WEBSITE_BUILDER_EDITOR_TEXT} />
                </span>
                <div className='website-builder-sidebar__restore-btn'>
                    <MinimizeIcon />
                </div>
            </div>
        );
    }

    const managePageVM = vm.getManagePageVM();
    const pageTabLabel = <FormattedMessage {...(managePageVM.isCreateMode() ? NEW_PAGE_PLACEHOLDER_TEXT : WEBSITE_BUILDER_EDIT_PAGE_TAB_TEXT)} />;
    const editHubTabLabel = vm.canAccessEditHubTab() ? <FormattedMessage {...WEBSITE_BUILDER_EDIT_HUB_TAB_TEXT} /> : null;

    return (
        <div className='website-builder-sidebar'>
            <SidebarHeader
                activeTab={vm.getActiveTab()}
                onTabClick={vm.setActiveTab}
                onMinimize={vm.toggleMinimize}
                pageTabLabel={pageTabLabel}
                editHubTabLabel={editHubTabLabel}
            />
            <SidebarContent vm={vm} />
        </div>
    );
});
